export default "__VITE_ASSET__B6olN1ym__"